import type { ComponentProps } from "react";
import { Link as RouterLink } from "react-router-dom";

import { cn } from "@/utils/cn";

interface LinkProps extends ComponentProps<"a"> {
  href: string;
}

const isExternalLink = (href: string) =>
  href.startsWith("http://") || href.startsWith("https://") || href.startsWith("//");

export const Link = ({ className, href, target, rel, ...props }: LinkProps) => {
  if (isExternalLink(href)) {
    return (
      <a
        className={cn("underline", className)}
        href={href}
        target={target ?? "_blank"}
        rel={rel ?? "noreferrer noopener"}
        {...props}
      />
    );
  }

  const { children, ...rest } = props;

  return (
    <RouterLink
      {...(rest as Omit<ComponentProps<typeof RouterLink>, "to">)}
      className={cn("underline", className)}
      to={href}
      target={target}
      rel={rel}
    >
      {children}
    </RouterLink>
  );
};
